import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

// Store
import { GoPaperLessActions, GoPaperLessSelectors } from '@amfam/policy/go-paperless/data-access';
import { AnalyticsFacade } from '@amfam/shared/analytics';
import { ImpersonateRolesService } from '@amfam/shared/utility/impersonation';
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { LoadingSpinnerService, PageTitleService } from '@amfam/ui-kit';

import * as fromRoot from '../../../core/store';
import { GoPaperlessComponentDirective } from '../shared';

@Component({
  selector: 'app-unenroll-go-paperless',
  templateUrl: './unenroll-go-paperless.component.html',
  styleUrls: ['./unenroll-go-paperless.component.scss'],
  standalone: false
})
export class UnenrollGoPaperlessComponent
  extends GoPaperlessComponentDirective
  implements OnInit, OnDestroy
{
  // Shared subject for completing observables
  private done$: Subject<void> = new Subject<void>();

  constructor(
    private location: Location,
    private pageTitle: PageTitleService,
    public spinner: LoadingSpinnerService,
    store: Store<fromRoot.RootState>,
    analyticsFacade: AnalyticsFacade,
    public roleService: ImpersonateRolesService
  ) {
    super(store, analyticsFacade);
    this.spinner.start();
  }

  unenroll() {
    this.store.dispatch(GoPaperLessActions.UnEnrollGoPaperless());
    combineLatest(
      this.store.select(GoPaperLessSelectors.selectGoPaperlessLoading),
      this.store.select(GoPaperLessSelectors.selectGoPaperlessError),
      (loading, hasError) => {
        return {
          hasError: hasError,
          loading: loading
        };
      }
    )
      .pipe(
        takeUntil(this.done$),
        filter(state => !state.loading)
      )
      .subscribe(state => {
        if (state.hasError) {
          this.analyticsFacade.trackPage(this.errorAnalytic);
        } else {
          this.store.dispatch(
            fromRouterActions.Go({
              path: ['/policies']
            })
          );
        }
      });
  }

  cancel() {
    this.location.back();
  }

  ngOnInit() {
    super.ngOnInit();
    this.pageTitle.set('Opt out of Paperless Policy Documents');
    this.spinner.stop();
  }

  ngOnDestroy() {
    super.ngOnDestroy();

    this.done$.next();
    this.done$.complete();
  }
}
